module.exports = __webpack_public_path__ + "img/2.267c592b.png";